import initialState from './initialState';

export function conversionRateListHasErrored(
  state = initialState.conversionRateListHasErrored,
  action,
) {
  switch (action.type) {
    case 'CONVERSION_RATE_LIST_HAS_ERRORED':
      return action.hasErrored;
    case 'RESET_ERROR_MESSAGE':
      return { hasErrored: false, errorMessage: '' };
    default:
      return state;
  }
}
export function conversionRateListIsLoading(
  state = initialState.conversionRateListIsLoading,
  action,
) {
  switch (action.type) {
    case 'CONVERSION_RATE_LIST_IS_LOADING':
      return action.isLoading;
    default:
      return state;
  }
}
export function conversionRateListData(
  state = initialState.conversionRateListData,
  action,
) {
  switch (action.type) {
    case 'CONVERSION_RATE_LIST_FETCH_DATA_SUCCESS':
      return action.items;
    default:
      return state;
  }
}

export function conversionRateAddHasErrored(
  state = initialState.conversionRateAddHasErrored,
  action,
) {
  switch (action.type) {
    case 'CONVERSION_RATE_ADD_HAS_ERRORED':
      return {
        hasErrored: action.hasErrored,
        errorMessage: action.errorMessage,
      };
    case 'RESET_ERROR_MESSAGE':
      return { hasErrored: false, errorMessage: '' };
    default:
      return state;
  }
}

export function conversionRateAddIsLoading(
  state = initialState.conversionRateAddIsLoading,
  action,
) {
  switch (action.type) {
    case 'CONVERSION_RATE_ADD_IS_LOADING':
      return action.isLoading;
    default:
      return state;
  }
}
export function conversionRateAddDataSuccess(
  state = initialState.conversionRateAddDataSuccess,
  action,
) {
  switch (action.type) {
    case 'CONVERSION_RATE_ADD_DATA_SUCCESS':
      return action.isConversionRateAddSuccess;
    default:
      return state;
  }
}

export function eftCategoriesListHasErrored(
  state = initialState.eftCategoriesListHasErrored,
  action,
) {
  switch (action.type) {
    case 'EFT_CODE_LIST_HAS_ERRORED':
      return action.hasErrored;
    case 'RESET_ERROR_MESSAGE':
      return { hasErrored: false, errorMessage: '' };
    default:
      return state;
  }
}
export function eftCategoriesListIsLoading(
  state = initialState.eftCategoriesListIsLoading,
  action,
) {
  switch (action.type) {
    case 'EFT_CODE_LIST_IS_LOADING':
      return action.isLoading;
    default:
      return state;
  }
}
export function eftCategoriesListData(
  state = initialState.eftCategoriesListData,
  action,
) {
  switch (action.type) {
    case 'EFT_CODE_LIST_FETCH_DATA_SUCCESS':
      return action.items;
    default:
      return state;
  }
}

export function conversionRateDeleteHasErrored(
  state = initialState.conversionRateDeleteHasErrored,
  action,
) {
  switch (action.type) {
    case 'CONVERSION_RATE_DELETE_ERRORED':
      return {
        hasErrored: action.hasErrored,
        errorMessage: action.errorMessage,
      };
    default:
      return state;
  }
}

export function conversionRateDeleteIsLoading(
  state = initialState.conversionRateDeleteIsLoading,
  action,
) {
  switch (action.type) {
    case 'CONVERSION_RATE_DELETE_IS_LOADING':
      return action.isLoading;
    default:
      return state;
  }
}
export function conversionRateDeleteDataSuccess(
  state = initialState.conversionRateDeleteDataSuccess,
  action,
) {
  switch (action.type) {
    case 'CONVERSION_RATE_DELETE_SUCCESS':
      return action.isSuccess;
    default:
      return state;
  }
}

export function conversionRateSetEndDateHasErrored(
  state = initialState.conversionRateSetEndDateHasErrored,
  action,
) {
  switch (action.type) {
    case 'CONVERSION_RATE_SET_END_DATE_ERRORED':
      return {
        hasErrored: action.hasErrored,
        errorMessage: action.errorMessage,
      };
    default:
      return state;
  }
}

export function conversionRateSetEndDateIsLoading(
  state = initialState.conversionRateSetEndDateIsLoading,
  action,
) {
  switch (action.type) {
    case 'CONVERSION_RATE_SET_END_DATE_IS_LOADING':
      return action.isLoading;
    default:
      return state;
  }
}
export function conversionRateSetEndDateDataSuccess(
  state = initialState.conversionRateSetEndDateDataSuccess,
  action,
) {
  switch (action.type) {
    case 'CONVERSION_RATE_SET_END_DATE_SUCCESS':
      return action.isSuccess;
    default:
      return state;
  }
}
